function SectionTabs({ items, value, onChange }) {
  return (
    <div className="section-tabs" role="tablist">
      {items.map((item) => {
        const active = item.id === value;
        return (
          <a
            key={item.id}
            href={item.href}
            className={active ? 'section-tabs__item is-active' : 'section-tabs__item'}
            role="tab"
            aria-selected={active}
            onClick={(event) => {
              if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
              event.preventDefault();
              if (!active) onChange(item.id);
            }}
          >
            {item.label}
            {item.count != null ? <span className="section-tabs__count">{item.count}</span> : null}
          </a>
        );
      })}
    </div>
  );
}

export default SectionTabs;
